<div #adContainer class="ads-wrapper" ngSkipHydration>
</div>